<template>
  <div>
    <div id="topicList">
      <div class="topicContent" v-if="topic">
        <Breadcrumb></Breadcrumb>
        <el-alert
          center
          v-if="!topic.published"
          title="话题未公开"
          type="warning"
        >
        </el-alert>
        <el-alert
          center
          v-if="topic.closed"
          title="话题已关闭，问题已经解决或者已经过了时效。"
          type="warning"
        >
        </el-alert>
        <div>
          <div class="text-center">
            <h3 class="click-to-copy" @click="copyUrl">
              {{ topic.title }}
              <price-label :price="topic.price"></price-label>
            </h3>
            <p style="color:var(--color-fg-subtle)">
              <router-link :to="topic.user.id == 0 ?'':'/users/' + topic.user.id">
                <el-avatar
                  class="alignAvatar"
                  fit="cover"
                  v-if="topic.user.avatar"
                  size="small"
                >
                  <img
                    loading="lazy"
                    :title="'用户' + topic.user.name"
                    :alt="topic.user.name"
                    :src="topic.user.avatar"
                  />
                </el-avatar>
                <el-avatar
                  v-else
                  icon="el-icon-user-solid"
                  style="vertical-align:middle"
                  size="small"
                >
                </el-avatar>
                &nbsp;&nbsp;&nbsp;{{ topic.user.name }}
              </router-link>
            </p>
          </div>
          <!--just add it here to make the style work-->
          <div class="ql-snow gadget">
            <div class="ql-editor">
              <vue-editor style="display:none"> </vue-editor>
              <div v-html="topic.body"></div>
            </div>
          </div>
          <p v-if="topic.condition">
            新旧程度：
            {{ getConditionName(topic.condition) }}
          </p>
          <div
            v-if="parsedImages.length > 0 || topic.zipcode"
            class="row gadget"
          >
            <!--        photos-->
            <div
              v-if="parsedImages.length > 0"
              :class="topic.zipcode ? 'col-md-6' : 'col-md-12'"
            >
              <el-carousel
                :interval="5000"
                trigger="click"
                height="180px"
                arrow="always"
                indicator-position="outside"
              >
                <el-carousel-item
                  v-for="(image, index) in parsedImages"
                  :key="index"
                >
                  <div class="topicPicWrapper">
                    <img
                      :alt="image.url"
                      class="topicPic"
                      :src="image.url"
                      @click="galleryIndex = index"
                    />
                  </div>
                </el-carousel-item>
              </el-carousel>
              <gallery
                :images="galleryImages"
                class="gallery"
                :index="galleryIndex"
                @close="index = null"
              ></gallery>
            </div>
            <!--        zipcode-->
            <TopicZipcodeLocation
              :class="parsedImages.length > 0 ? 'col-md-6' : 'col-md-12'"
              v-if="topic.zipcode"
              :latitude="topic.latitude"
              :longitude="topic.longitude"
            >
            </TopicZipcodeLocation>
          </div>

          <!--        tags  -->
          <div v-if="topic.tags.length > 0" class="gadget">
            <el-tag
              @click="goToTag(tag)"
              :key="tag.id"
              v-for="tag in topic.tags"
            >
              {{ tag.name }}
            </el-tag>
          </div>
          <div class="gadget">
            <span class="topicShowFooter">
              <span
                @click="likeTopic"
                id="likeButton"
                :class="liked === 1 ? 'liked' : ''"
                title="点赞数"
                >👍&nbsp;{{ topic.like_count }}</span
              >
<!--              &nbsp;&nbsp;<span title="浏览数"-->
<!--                >👀&nbsp;{{ topic.view_count }}</span-->
<!--              >-->
<!--              <el-divider direction="vertical"></el-divider>-->
<!--              <span title="回复数">💬&nbsp; {{ topic.reply_count }}</span>-->
<!--              <el-divider direction="vertical"></el-divider>-->
              &nbsp;&nbsp; <span :title="'创建时间:' + topic.created_at"
                >🕒
                {{ topic.created_at | moment("from") }}
              </span>
              <el-divider direction="vertical"></el-divider>
              <el-popover trigger="click" width="99">
                <img
                  class="barcode"
                  :src="barcodeUrl"
                  width="99px"
                  height="99px"
                />
                <span slot="reference" class="pointer">📱微信扫描</span>
              </el-popover>
            </span>
            <!--        topic options-->
            <TopicOptionComponent
                :topic="topic"
                @refresh="init"
                :admin="admin"></TopicOptionComponent>
          </div>
        </div>

        <el-divider></el-divider>
        <el-card v-if="topic.closed">
          ✋ 无法回复已关闭的话题
        </el-card>
        <div v-else>
          <div v-if="isLoggedIn">
            <div id="replyBoxWrapper">
              <div @click="triggerReplyBox">
                <el-avatar
                  size="medium"
                  class="alignAvatar"
                  v-if="user.avatar"
                  fit="cover"
                >
                  <img
                    loading="lazy"
                    :title="'用户' + user.name"
                    :alt="user.name"
                    :src="user.avatar"
                  />
                </el-avatar>
                <el-avatar
                  v-else
                  style="vertical-align:middle"
                  size="medium"
                  icon="el-icon-user-solid"
                >
                </el-avatar>
                <span>&nbsp;&nbsp;&nbsp; 回复话题...</span>
              </div>
              <div id="replyTextArea" style="display:none;">
                <b-form-textarea
                  id="textarea-auto-height"
                  v-model="replyContent"
                  style="border: none; background-color: unset"
                  autofocus
                  rows="5"
                  max-rows="8"
                ></b-form-textarea>
                <span style="display: block"
                  >回复发布后只能删除，不能修改。如果需要管理员帮助或举报该话题，可以在文字中使用"@管理员"。
                  <a href="#" @click.prevent="pasteAtAdmin"
                    >添加"@管理员"</a
                  ></span
                >
                <el-button
                  @click="postReply"
                  style="display:block;"
                  class="float-right"
                  >回复
                </el-button>
              </div>
            </div>
          </div>
          <el-card v-else>
            <a @click="setShowLoginModalSwitch(true)">
              👉 登录后回复
            </a>
          </el-card>
        </div>
        <!--&#45;&#45; 用户回复列表 &#45;&#45;-->
        <ReplyListComponent
          :id="this.id"
          :key="replyListKey"
          :admin="admin"
          v-on:topicDeleted="fetchTopic"
        ></ReplyListComponent>
      </div>

    </div>
    <div class="fixedWidget desktopView">
      <UserSidebarComponent v-if="topic && topic.user.id !== 0" :id="topic.user.id">
      </UserSidebarComponent>
    </div>
    <el-dialog title="转移话题" :visible.sync="transferDialog">
      <span slot="footer" class="dialog-footer">
        <el-button @click="transferDialog = false">取消</el-button>
        <el-button type="primary" @click="transferDialog = false"
          >确认转移到自己账户</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
import { mapState } from "vuex";
import ReplyListComponent from "../components/ReplyListComponent.vue";
import TopicZipcodeLocation from "../components/TopicZipcodeLocation.vue";
import VueGallery from "vue-gallery";
import Breadcrumb from "../components/Breadcrumb";
import $ from "jquery";
import UserSidebarComponent from "../components/UserSidebarComponent";
import PriceLabel from "@/components/PriceLabel";
import TopicOptionComponent from "@/components/TopicOptionComponent";

export default {
  metaInfo() {
    return {
      title: this.topic.title,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.topic.excerpt
        },
        {
          vmid: "og:title",
          name: "og:title",
          content: this.topic.title
        },
        {
          vmid: "og:description",
          name: "og:description",
          content: this.topic.excerpt
        },
        {
          vmid: "og:image",
          name: "og:image",
          content: this.topic.image_url ? this.topic.image_url : undefined
        },
        {
          vmid: "og:type",
          name: "og:type",
          content: "article"
        },
        {
          vmid: "og:url",
          name: "og:url",
          content: this.$route.fullPath
        },
        {
          vmid: "article:published_time",
          name: "article:published_time",
          content: this.topic.created_at ? this.topic.created_at : undefined
        },
        {
          vmid: "article:author",
          name: "article:author",
          content: this.topic.user ? this.topic.user.name : undefined
        },
        {
          vmid: "article:section",
          name: "article:section",
          content: this.topic.title
        },
        {
          vmid: "article:tag",
          name: "article:tag",
          content: this.topic.tags
            ? this.topic.tags.map(t => t.name)
            : undefined
        }
      ],
      link: [
        {
          once: true,
          rel: "canonical",
          href: "/topics/" + this.topic.id
        }
      ]
    };
  },
  data: function() {
    return {
      topic: "",
      replyContent: "",
      replyListKey: 0,
      liked: 0,
      barcodeUrl:
        "https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=" +
        window.location.href,
      galleryIndex: null,
      transferDialog: false
    };
  },
  props: ["id", "admin"],
  watch: {
    "user.notification_count": function() {
      this.replyListKey++;
    },
    liked: function(newVal) {
      if (newVal === 1) {
        $("#likeButton").addClass("liked");
      } else {
        $("#likeButton").removeClass("liked");
      }
    },
    isLoggedIn: function(newVal) {
      if (newVal) {
        this.didILike();
      }
    }
  },
  computed: {
    ...mapGetters([
      "isLoggedIn",
      "getCategoryColorById",
      "getCategoryNameById"
    ]),
    ...mapState(["user"]),
    parsedImages: function() {
      return this.topic.images ? JSON.parse(this.topic.images) : [];
    },
    galleryImages: function() {
      return this.parsedImages.map(function(parsedImage) {
        return parsedImage.url;
      });
    }
  },
  methods: {
    ...mapMutations([
      "changeCurrentCategory",
      "setLoading",
      "setShowLoginModalSwitch"
    ]),
    getConditionName: function(condition) {
      switch (condition) {
        case "new":
          return "全新";
        case "used-like-new":
          return "九成新";
        case "used-good":
          return "七八成新";
        case "used-fair":
          return "五六成新";
      }
    },
    transferTopic: function() {
      const transferCode = new URLSearchParams(window.location.search).get(
        "transfer"
      );

      if (!transferCode) {
        return;
      }

      if (!this.isLoggedIn) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: "先注册/登录账户，才能转移话题到你自己账户下！",
          type: "info",
          showClose: true,
          duration: "20000"
        });
      }

      this.setLoading(true);
      this.$axios
        .put("/topics/" + this.topic.id + "/transfer", { code: transferCode })
        .then(() => {
          this.setLoading(false);
          this.$message({
            showClose: true,
            message: "话题转移成功，正在刷新",
            type: "success"
          });
          setTimeout(function() {
            var location =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname;
            window.location.href = location;
          }, 2000);
        })
        .catch(e => {
          console.log(e);
          this.setLoading(false);
          this.$message({
            showClose: true,
            type: "error",
            message: "话题转移失败，请稍后重试"
          });
          // console.log(e.response.data)
        });
    },
    deleteTopic: function() {
      const deleteCode = new URLSearchParams(window.location.search).get(
          "delete"
      );

      if (!deleteCode) {
        return;
      }

      this.setLoading(true);
      this.$axios
          .put("/topics/" + this.topic.id + "/delete", { code: deleteCode })
          .then(() => {
            this.setLoading(false);
            this.$message({
              showClose: true,
              message: "话题删除成功",
              type: "success"
            });
            setTimeout(function() {
              var location =
                  window.location.protocol +
                  "//" +
                  window.location.host +
                  window.location.pathname;
              window.location.href = location;
            }, 2000);
          })
          .catch(e => {
            console.log(e);
            this.setLoading(false);
            this.$message({
              showClose: true,
              type: "error",
              message: "话题删除失败，请稍后重试"
            });
            // console.log(e.response.data)
          });
    },
    copyUrl: function() {
      if (navigator.clipboard == null) {
        this.$message({
          message: "复制失败，请手动复制URL",
          type: "error"
        });
      }
      navigator.clipboard.writeText(window.location.href).then(
        () => {
          this.$message({
            message: "复制成功",
            type: "success"
          });
        },
        () => {
          this.$message({
            message: "复制失败，请手动复制URL",
            type: "error"
          });
        }
      );
    },
    didILike() {
      this.$http.get("/topics/" + this.id + "/liked").then(res => {
        this.liked = res.data;
      });
    },
    likeTopic() {
      if (this.isLoggedIn) {
        $("#likeButton").html("👍&nbsp;" + this.topic.like_count + "...");
        this.$http.put("/topics/" + this.topic.id + "/likers").then(res => {
          if (res.status === 201) {
            this.liked = res.data;
            if (res.data === 1) {
              this.topic.like_count++;
            } else {
              this.topic.like_count--;
            }
          }
          $("#likeButton").html("👍&nbsp;" + this.topic.like_count);
        });
      } else {
        this.$message({
          message: "请先登录",
          type: "success"
        });
      }
    },
    goToTag(tag) {
      this.$router.push({
        path: "/tags/" + tag.id + "/" + tag.slug,
        query: { tagName: tag.name }
      });
    },
    pasteAtAdmin: function() {
      this.replyContent += " @管理员 ";
    },

    fetchTopic: function() {
      this.setLoading(true);
      this.$axios
        .get("/topics/" + this.id)
        .then(response => {
          this.topic = response.data;
          this.changeCurrentCategory(this.topic.category_id);
          this.setLoading(false);
          this.transferTopic();
          this.deleteTopic();
        })
        .catch(err => {
          if (err.response.status == 404) {
            this.$message({
              message: "话题被删除，跳转至主页面中",
              type: "error",
              duration: 2000
            });
            this.setLoading(false);
            let self = this;
            setTimeout(function() {
              self.$router.push("/");
            }, 3000);
          }
        });
    },

    postReply: function() {
      if (this.replyContent) {
        this.setLoading(true);
        this.$http
          .post("/topics/" + this.topic.id + "/replies", {
            content: this.replyContent
          })
          .then(res => {
            if (res.status === 201) {
              this.$message({
                message: "回复创建成功",
                type: "success"
              });
              this.replyContent = "";
              this.replyListKey++;
              this.fetchTopic();
              $("#replyTextArea").hide(300);
            }
            this.setLoading(false);
          });
      }
    },
    init: function() {
      this.fetchTopic();
      $(document).mouseup(function(e) {
        var container = $("#replyBoxWrapper");

        // If the target of the click isn't the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $("#replyTextArea").hide(300);
        }
      });
      if (this.isLoggedIn) {
        this.didILike();
      }
    },

    triggerReplyBox: function() {
      var element = $("#replyTextArea");
      if (!element.is(":visible")) {
        element.show(300);
      }
      $("#textarea-auto-height").focus();
    }
  },
  // fetch the topic when it's mounted.
  mounted: function() {
    this.init();
  },
  components: {
    TopicOptionComponent,
    PriceLabel,
    UserSidebarComponent,
    Breadcrumb,
    ReplyListComponent,
    TopicZipcodeLocation,
    gallery: VueGallery
  }
};
</script>
<style lang="scss">
.ql-picker-label {
  display: flex !important;
}

.topicContent {
  margin-bottom: 30px;
}

#topicList {
  width: 746px;
  margin: auto;
}

.topicOptions {
  float: right;
  position: relative;
  cursor: pointer;
}

.fixedWidget {
  position: fixed;
  top: 100px;
  right: 50px;
  max-width: 200px;
  z-index: 1000;
}

.topicPic {
  height: 180px;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: contain;
}

.topicPicWrapper {
  display: flex;
  justify-content: center;
  height: 180px;
  width: 100%;
}

.gallery a {
  color: white !important;
}

.liked {
  background-color: var(--color-checks-line-selected-bg);
  color: var(--color-fg-muted);
}

#likeButton {
  padding: 10px;
  font-size: 15px;
  border: 1px solid var(--color-border-subtle);
  border-radius: 5px;
  cursor: pointer;
  transition: border-color 150ms ease;
}
#likeButton:hover {
  border-color: var(--color-accent-emphasis);
}

#replyBoxWrapper {
  border: var(--color-border-default);
  padding: 10px 20px;
  border-radius: 3px;
  box-shadow: 0 1px 4px var(--color-border-subtle);
  font-size: 12px;
  color: gray;
  margin: 20px 0;
  display: flow-root;
}

#textarea-auto-height:focus {
  outline: none;
  box-shadow: unset;
}

.topicShowFooter {
  color: gray;
}
.barcode {
  display: block;
  margin: auto;
}

@media only screen and (max-device-width: 768px) {
  .fixedWidget {
    position: static;
    top: unset;
    right: unset;
  }
  #topicList {
    width: 100%;
  }
}
</style>
